/** Class containing orchestration logic and event handlers for the change location popup. */
class ChangeLocationPopup {
    /* change location popup element */
    el;
    /* change location button element */
    changeLocationButton;
    /* change location popup close button element */
    closeButton;

    /** Retrieves DOM elements for the change location popup and handles open and close logic. */
    constructor() {
        this.el = document.querySelector('[data-change-location-popup]');
        if (this.el) {
            this.addChangeLocationEventListener();
            this.addCloseButtonEventListener();
        }
    }

    /**
     * Retrieves change location button DOM element, sets DOM element to class property, and adds functionality to
     * open popup on click event.
     */
    addChangeLocationEventListener() {
        this.changeLocationButton = document.getElementById(
            'change-location-popup-button'
        );
        this.changeLocationButton.addEventListener(
            'click',
            this.openChangeLocationPopup.bind(this)
        );
    }

    /**
     * Retrieves change location popup close button DOM element, sets DOM element to class property, and adds
     * functionality to close popup on click event.
     */
    addCloseButtonEventListener() {
        this.closeButton = this.el.querySelector('.close-button');
        this.closeButton.addEventListener(
            'click',
            this.closeChangeLocationPopup.bind(this)
        );
    }

    /** Displays the change location popup using jQuery and Foundation. */
    openChangeLocationPopup() {
        $('#change-location-popup').foundation('open');
    }

    /** Hides the change location popup using jQuery and Foundation. */
    closeChangeLocationPopup() {
        $('#change-location-popup').foundation('close');
    }
}

const init = () => {
    new ChangeLocationPopup();
};

export { init };
